<div id="pagination" class="media">
  <div class="row float-left">
    <span>Items per page: </span>
    <span class="selector-main">
      <select id="step-select" [(ngModel)]="step" (ngModelChange)="updatingStepEventEmitter()">
        <option *ngFor="let step of steps" [ngValue]="step">
          {{ step }}
        </option>
      </select>
    </span>
    <span>
      | {{ retrieveMinSizeOfDisplayedData() }}
      - {{ retrieveMaxSizeOfDisplayedData() }}
    of {{ retrieveSizeOfDisplayedData() }} items </span>
  </div>
  <div class="row float-right pagination-right-main" id="pagination-button">
    <span class="number-of-pages-main">
      {{ filteredData.length === 0 ? 0: page + 1 }} of {{ maxPage }} page(s)
    </span>
    <button class="page-selector-main" [disabled]="isPreviousButtonDisabled"
            (click)="clickPreviousButtonEventEmitter()">
      <i class="fa fa-angle-left page-icon" aria-hidden="true"></i>
    </button>
    <span class="selector-main">
      <select id="page-select-main" [(ngModel)]="page" (ngModelChange)="updatingStepEventEmitter()">
        <option *ngFor="let i of pages" [ngValue]="i">
          {{ i + 1 }}
        </option>
      </select>
    </span>
    <button class="page-selector-main" [disabled]="isNextButtonDisabled" (click)="clickNextButtonEventEmitter()">
      <i class="fa fa-angle-right page-icon" aria-hidden="true"></i>
    </button>
  </div>
</div>
